import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidVisitorNameCharactersError extends CodedError {
  static get errorName() {
    return errorCodes.invalidVisitorNameCharactersError.code;
  }

  constructor(
    message: string = errorCodes.invalidVisitorNameCharactersError.message
  ) {
    super(message);
    this.code = errorCodes.invalidVisitorNameCharactersError.code;
    this.message = `${message} ${errorCodes.invalidVisitorNameCharactersError.code}`;
    this.name = errorCodes.invalidVisitorNameCharactersError.name;
  }
}
